export default {
    banner: {
        background: "#fef8e2" /* Yellow background */,
        padding: "20px" /* Increased padding for better scaling */,
        textAlign: "center",
        fontWeight: "bold",
        margin: "10px 0" /* Add some space around the banner */,
        boxShadow: " 0px 4px 4px rgba(0, 0, 0, 0.25)",
        borderRadius: "12px",

        display: "flex" /* Use flexbox to align items */,
        alignItems: "center" /* Center items vertically */,
        justifyContent: "center" /* Center items horizontally */
    },
    message: {
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "23px",
        color: "#955100"
    }
};



// WEBPACK FOOTER //
// ./src/components/Common/BannerNotificationAlerts/styles.js